export const title = 'No views were found';
export const subTitle = 'Please try again or contact support';
export const home = 'Home';
